type Props = {
  onReset: () => void
}

const SIGNUP_URL =
  'https://app.spendifique.com/register?utm_source=invoice_splitter&utm_campaign=ratelimit'

/**
 * Shown when the backend returns 429. Light-hearted copy + a soft sell —
 * if a user is processing this many PDFs they're a real prospect, not abuse.
 */
export default function RateLimitView({ onReset }: Props) {
  return (
    <div class="sis-ratelimit">
      <div class="sis-ratelimit-emoji" aria-hidden="true">
        🤯
      </div>
      <h2 class="sis-ratelimit-title">Whoa, that's a lot of PDFs.</h2>
      <p class="sis-ratelimit-body">
        Our free tool processes up to <strong>100 files per hour</strong> to
        keep things fast for everyone.
      </p>
      <p class="sis-ratelimit-body">
        If you're processing this much volume regularly, Spendifique handles
        it automatically — no limits.
      </p>
      <div class="sis-ratelimit-actions">
        <a class="sis-button" href={SIGNUP_URL} target="_blank" rel="noreferrer noopener">
          Get 30 free scans →
        </a>
        <button type="button" class="sis-link sis-link--button" onClick={onReset}>
          Try again later
        </button>
      </div>
    </div>
  )
}
